function CartReload(data) {
  var container = document.getElementById('cart-table')
  var tT = document.getElementById('total-top');
  var c = document.querySelector('.cart-table');
  var tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top');
  var nC = htmlDocument.documentElement.querySelector('.cart-table');
  var nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  Quantity(container);
  CartButtons();
}

let poCartChanging = false;
async function CartChange(control, container) {
  if (poCartChanging) return;
  const item = control.closest('[data-product-id]');
  const input = item.querySelector('.item-qty');
  const quantity = Number(input.value);
  const error = document.getElementById('po-cart-error');
  const labels = JSON.parse(document.getElementById('po-cart-labels')?.textContent || '{}');
  if (input.value.trim() === '' || !Number.isInteger(quantity) || quantity < 0) {
    if (error) { error.hidden = false; error.textContent = labels.invalid_quantity; }
    return;
  }
  const busy = document.getElementById('ajaxBusy');
  if (error) error.hidden = true;
  poCartChanging = true;
  container.setAttribute('aria-busy', 'true');
  busy.style.display = 'block';
  try {
    const response = await fetch(theme.routes_cart_change_url + '.js', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({quantity, id:item.dataset.productId}), signal:AbortSignal.timeout(15000)
    });
    const cart = await response.json();
    if (!response.ok || cart.status) throw Error('CART_UPDATE_FAILED');
    document.querySelectorAll('.cartCountSelector').forEach(node => {node.textContent = cart.item_count;});
    if (cart.item_count === 0) {
      container.querySelector('.full-form').classList.add('hidden');
      container.querySelector('.empty-form').classList.remove('hidden');
      document.querySelectorAll('.cartTotalSelector').forEach(node => {node.innerHTML = Shopify.formatMoney(0,theme.moneyFormat);});
      document.getElementById('cart-dropdown')?.classList.add('hidden');
    } else {
      const updated = await fetch(theme.routes_cart_url, {cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (!updated.ok) throw Error('CART_RENDER_FAILED');
      CartReload(await updated.text());
      CartDrop(true);
    }
  } catch (failure) {
    if (error) { error.hidden = false; error.textContent = labels.update_failed; }
  } finally {
    busy.style.display = 'none';
    container.removeAttribute('aria-busy');
    poCartChanging = false;
  }
}

function CartButtons() {
  var container = document.getElementById('cart-table'),
      qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.quantity.form'),
          vV = qF.querySelector('.item-qty').value,
          vM = qF.querySelector('.item-qty').getAttribute('max');
    };
    setTimeout(function () {
      q.onclick = function(ev){
        if (vM && vM == vV) {
          return;
        }
        CartChange(q,container);
      }
    }, 1);
  })  
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    let timeout;
    var vV = q.value,
        vM = q.getAttribute('max');
    q.addEventListener('input', function (e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (vM && nV == vV && vM == nV) {
          return;
        }
        CartChange(q,container);
      }, 750);
    });
  });  
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id');
    var chk = container.getAttribute('data-check');
    var rct = container.getAttribute('data-recent');
    var rV = document.getElementById('recently-viewed');
    var rVP = document.getElementById('recently-viewed-placeholder');
    theme.cart = true;
    Quantity(container);
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
        }
      };
    };
    CartButtons(container);
    if(rct == 'true'){
      function gPD (){
        const pD = JSON.parse(localStorage.getItem('rVP'));
        const rVH = []
        if (pD) {
          rV.classList.remove('hidden');          
          pD.forEach(function(item,i){
            rVH.push('id:' + item.pID);
          });
          const rB = rVH.join('%20OR%20');
          fetch(theme.routes_search_url + '?section_id=recently-viewed&q=' + rB + '&type=product')
          .then(response => response.text())
          .then(data => {   
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(data, 'text/html');
            var rVD = document.querySelector('.recently-viewed');
            var cP = htmlDocument.documentElement.querySelector('.collection-products');
            rVP.remove();
            rVD.appendChild(cP);
            if (theme.settings.quickView) {
              Quick();
            };
            if (theme.settings.compare) {
              CompareProducts();
            };
            Swatches(container);
            if (theme.settings.cart) {
              var sI = cP.getAttribute('data-section-id');
              Cart(container,sI);
            }
          }).catch(function (err) {
            console.log('!: ' + err);
          });
        }
      }    
      gPD();
    };
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();